import './templates_page.less';

import * as Groups    from '../groups';
import * as Templates from '../campaign_templates';
import Link           from '../components/link';
import Navbar         from '../components/navbar';
import React          from 'react';

import { ArrowRight } from 'react-feather';


export default function TemplatesPage({ businessID, navigateTo }) {
  const templates = Templates.useTemplates(businessID);

  return (
    <>
      <Navbar title="Templates"/>
      <div className="page-content">
        {templates?.map(template => (
          <TemplateLink key={template.name} {...{ template, businessID, navigateTo }}/>
        ))}
      </div>
    </>
  );
}

function TemplateLink({ template, businessID, navigateTo }) {
  const { name, title, description } = template;

  const group = Groups.useGroup(template.group);
  const href  = `/${businessID}/campaigns/add?template=${name}`;

  function onClick() {
    navigateTo(href);
  }

  return (
    <div className="template" onClick={onClick}>
      <h3 className="title">{title}</h3>
      <p className="description">{description}</p>
      {group && (
        <p className="suggested-group">
          <span className="label">Suggested Group:</span> {group.title}
        </p>
      )}
      <div className="template-actions">
        <Link className="use-template" href={href}>Use template <ArrowRight/></Link>
      </div>
    </div>
  );
}
